import { render, staticRenderFns } from "./GroupVirtualList.vue?vue&type=template&id=80f9636a&"
import script from "./GroupVirtualList.vue?vue&type=script&lang=js&"
export * from "./GroupVirtualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports